@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>Users</h4>
    </div>

    <div class="btn-container">
      <button class="button" type="button" (click)="showAddUser.set(true)">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M20 18L14 18M17 15V21M7.68213 14C8.63244 14.6318 9.77319 15 10.9999 15C11.7012 15 12.3744 14.8797 13 14.6586M10.5 21H5.6C5.03995 21 4.75992 21 4.54601 20.891C4.35785 20.7951 4.20487 20.6422 4.10899 20.454C4 20.2401 4 19.9601 4 19.4V17C4 15.3431 5.34315 14 7 14H7.5M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
              stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
        </svg>

        <p>Add a user</p>
      </button>
    </div>
  </section>

  <section class="data-cards">
    <div class="data-card academic-year">
      <div class="top-heading">
        <div>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#6c242b">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g id="User / Users_Group">
                <path id="Vector"
                      d="M17 20C17 18.3431 14.7614 17 12 17C9.23858 17 7 18.3431 7 20M21 17.0004C21 15.7702 19.7659 14.7129 18 14.25M3 17.0004C3 15.7702 4.2341 14.7129 6 14.25M18 10.2361C18.6137 9.68679 19 8.8885 19 8C19 6.34315 17.6569 5 16 5C15.2316 5 14.5308 5.28885 14 5.76389M6 10.2361C5.38625 9.68679 5 8.8885 5 8C5 6.34315 6.34315 5 8 5C8.76835 5 9.46924 5.28885 10 5.76389M12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14Z"
                      stroke="#6c242b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
            </g>
          </svg>

        </div>
        <p>+{{ dashboardData()?.users?.newThisMonth ?? 'No data' }} this month</p>
      </div>

      <h4>{{ dashboardData()?.users?.total ?? 'No data' }}</h4>
      <p>Total User(s)</p>
      <small>All registered accounts</small>

      <div class="card-bg"></div>
    </div>

    <div class="data-card subject">
      <div class="top-heading">
        <div>
          <svg fill="#1d4ed8" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <g> <g> <path
              d="M498.757,74.817h-62.081L365.922,4.062c-5.416-5.417-14.197-5.417-19.613,0l-70.754,70.753h-62.082 c-7.111,0-12.874,5.764-12.874,12.874v96.609l14.322-8.892c10.252-6.365,22.669-7.179,33.407-2.796l47.98-37.832 c7.218-5.692,17.683-4.452,23.372,2.764c5.691,7.217,4.453,17.682-2.764,23.372l-46.771,36.879 c3.782,15.127-2.369,31.596-16.326,40.262l-27.472,17.057L200.6,271.1v28.015c0,7.111,5.764,12.874,12.874,12.874h285.283 c7.111,0,12.874-5.764,12.874-12.874V87.691C511.631,80.581,505.867,74.817,498.757,74.817z M314.781,74.817l41.335-41.335 l41.335,41.335H314.781z"></path> </g> </g>
              <g> <g> <path
                d="M250.033,197.008c-5.371-8.651-16.738-11.309-25.387-5.938l-37.337,23.182c-0.155-30.964-0.073-14.527-0.173-34.473 c-0.12-23.935-19.692-43.408-43.628-43.408H125.37c-4.612,11.961-16.241,42.121-19.723,51.152l36.901,16.939v-24.537 c0-2.131,1.727-3.859,3.859-3.859s3.859,1.727,3.859,3.859c0,0.013,0,0.027,0,0.04l0.407,68.862 c1.149,13.809,16.49,21.334,28.091,14.13l65.333-40.565C252.746,217.024,255.404,205.659,250.033,197.008z"></path> </g> </g>
              <g> <g> <path
                d="M44.898,288.234l0.009,201.644c0,12.219,9.904,22.123,22.123,22.123c12.219,0,22.123-9.904,22.123-22.123V313.047h8.403 C95.784,312.464,44.898,288.234,44.898,288.234z"></path> </g> </g>
              <g> <g> <path
                d="M142.548,265.148l-16.221,35.333c-4.764,10.377-16.5,15.956-27.624,12.914v176.482c0,12.219,9.904,22.123,22.123,22.123 c12.219,0,22.123-9.904,22.123-22.123C142.929,478.727,142.548,277.44,142.548,265.148z"></path> </g> </g>
              <g> <g> <path
                d="M106.462,166.368l-7.496-13.632l6.65-12.096c0.991-1.803-0.315-4.016-2.375-4.016H84.97c-2.057,0-3.367,2.211-2.375,4.016 l6.665,12.12l-7.509,13.657c-0.872,1.587-1.156,3.428-0.804,5.203l2.628,13.236c7.868-2.859,13.773-1.141,20.462,1.929 l3.21-15.117C107.629,169.865,107.35,167.983,106.462,166.368z"></path> </g> </g>
              <g> <g> <path
                d="M138.113,218.299l-42.707-19.606c-4.598-2.11-10.03-0.091-12.138,4.5L72.22,227.261l22.494,12.497 c16.069,8.928,21.858,29.191,12.93,45.26c-2.77,4.987-6.641,8.971-11.133,11.846l4.573,2.099c4.598,2.11,10.03,0.091,12.138-4.5 l29.391-64.027C144.722,225.842,142.707,220.408,138.113,218.299z"></path> </g> </g>
              <g> <g> <circle cx="93.928" cy="85.985" r="38.208"></circle> </g> </g>
              <g> <g> <path
                d="M87.502,252.737l-50.195-27.888c0.103-16.785,0.18-29.136,0.276-44.884c0-0.001,0-0.001,0-0.002 c0.011-2.016,1.652-3.643,3.668-3.638s3.647,1.642,3.647,3.659v32.096l14.677,8.155l10.586-23.059 c2.399-5.227,6.595-9.294,11.651-11.606c-2.069-5.367-16.89-43.804-18.97-49.198H44.34c-23.937,0-43.507,19.474-43.627,43.387 c-0.05,8.073-0.294,47.732-0.344,55.786c-0.042,6.736,3.594,12.958,9.482,16.229l59.744,33.193 c8.899,4.946,20.124,1.74,25.069-7.161C99.608,268.907,96.402,257.682,87.502,252.737z"></path> </g> </g> </g></svg>
        </div>
        <p>{{ (dashboardData()?.teachers?.active | number: '1.0-0') ?? 'No data' }} Active</p>
      </div>

      <h4>{{ dashboardData()?.teachers?.total ?? 'No data' }}</h4>
      <p>Teacher(s)</p>
      <small>Users with role, teacher</small>

      <div class="card-bg"></div>
    </div>

    <div class="data-card term">
      <div class="top-heading">
        <div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 18.3333C10 18.3333 16.6667 15 16.6667 9.99999V4.16666L10 1.66666L3.33337 4.16666V9.99999C3.33337 15 10 18.3333 10 18.3333Z"
              stroke="#7A6000" stroke-width="1.41667" />
          </svg>
        </div>
        <p>{{ (dashboardData()?.schoolAdmins?.active | number: '1.0-0') ?? 'No data' }} Active</p>
      </div>

      <h4>{{ dashboardData()?.schoolAdmins?.total ?? 'No data' }}</h4>
      <p>School Admin(s)</p>
      <small>Administrative staff</small>

      <div class="card-bg"></div>
    </div>

    <div class="data-card level">
      <div class="top-heading">
        <div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#15803D" stroke-width="1.41667" />
          </svg>
        </div>
        <p>{{ (dashboardData()?.activeUsers?.percentage | number: '1.0-0') ?? 'No data' }}% Active</p>
      </div>

      <h4>{{ dashboardData()?.activeUsers?.total ?? 'No data' }}</h4>
      <p>Active User(s)</p>
      <small>Currently enabled</small>

      <div class="card-bg"></div>
    </div>
  </section>

  <!--<button (click)="getUsers('status', '')" type="button" class="button reset">Reset filters</button>-->
  <section class="table-content">

    <section class="filters">
      <input (input)="getUsers('search', search)" [(ngModel)]="search" type="search" name="" id=""
             placeholder="Search name, username...">

      <div>
        <select (change)="getUsers('status', status)" [(ngModel)]="status" name="status" id="status">
          <option value="" hidden disabled>Select a status</option>
          <option value="ACTIVE">Active</option>
          <option value="SUSPENDED">Suspended</option>
          <option value="DEACTIVATED">Deactivated</option>
          <option value="">All Status</option>
        </select>

        <select (change)="getUsers('role', role)" [(ngModel)]="role" name="role" id="role">
          <option value="" hidden disabled>Select a role</option>
          <option value="TEACHER">Teacher</option>
          <option value="SCHOOL_ADMIN">School Administrator</option>
          <option value="FINANCE_ADMIN">Finance Administrator</option>
          <option value="">All Roles</option>

        </select>

        @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
          <select (change)="getUsers('school', schoolId)" [(ngModel)]="schoolId" name="schoolId" id="schoolId">
            <option value="" hidden disabled>Select a school</option>

            @for (s of schools()?.payload; track $index) {
              <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
            }

          </select>
        }
      </div>

    </section>

    <div class="table-wrapper">
      <table>
        <thead>
        <tr>
          <th>USER ID</th>
          <th>USERNAME</th>
          <th>FULL NAME</th>
          <th>ROLE</th>
          <th>STATUS</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @if (isFiltering()) {
            <td colspan="6">
              <app-loading-indicator />
            </td>
          } @else {
            @if (!users()?.payload?.length) {
              <tr>
                <td colspan="6" class="empty">
                  <app-not-found-error>
                    NO USER RECORDS FOUND
                  </app-not-found-error>
                </td>
              </tr>
            } @else {
              @for (u of users()?.payload; track u.id) {
                <tr>
                  <td>
                    {{ u.public_id }}
                  </td>

                  <td>
                    {{ u.username }}
                  </td>

                  <td>
                    {{ Helpers.capitalizeWords(Helpers.fullName(u)) }}
                  </td>

                  <td class="role">
                    <p [ngClass]="u.role">{{ Helpers.replaceUnderscore(u.role) }}</p>
                  </td>

                  <td class="status">
                    <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                  </td>

                  <td class="options-column">
                    @if (loggedUsername !== u.username) {
                      <app-action-button>
                        <button class="menu-item"
                                (click)="selectUser(u.id, 'role', Helpers.capitalizeWords(Helpers.fullName(u)),'', u.role)">
                          Change role
                        </button>

                        @if (u.status !== 'PENDING') {
                          <button class="menu-item"
                                  (click)="selectUser(u.id, 'status', Helpers.capitalizeWords(Helpers.fullName(u)),u.status)">
                            Change status
                          </button>
                        }

                        <button class="menu-item"
                                (click)="selectUser(u.id, 'reset', Helpers.capitalizeWords(Helpers.fullName(u)), '', '', u)">
                          Reset password
                        </button>
                      </app-action-button>
                    }
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [page]="users()?.pagination?.page ?? 0"
      [size]="users()?.pagination?.size ?? 10"
      [totalElements]="users()?.pagination?.totalElements ?? 0"
      [totalPages]="users()?.pagination?.totalPages ?? 0"
      [first]="users()?.pagination?.first ?? true"
      [last]="users()?.pagination?.last ?? false"
      [hasNext]="users()?.pagination?.hasNext ?? false"
      [hasPrevious]="users()?.pagination?.hasPrevious ?? false"
      (pageChange)="loadPage($event)">
    </app-pagination>

  </section>


  @if (changeRole()) {
    <section class="pop-up">
      <div class="bg" (click)="changeRole.set(false)"></div>

      <form #changeRoleForm="ngForm" (ngSubmit)="editUser(changeRoleForm, 'role')">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="m27.3 37.6c-3-1.2-3.5-2.3-3.5-3.5 0-1.2 0.8-2.3 1.8-3.2 1.8-1.5 2.6-3.9 2.6-6.4 0-4.7-2.9-8.5-8.3-8.5s-8.3 3.8-8.3 8.5c0 2.5 0.8 4.9 2.6 6.4 1 0.9 1.8 2 1.8 3.2 0 1.2-0.5 2.3-3.5 3.5-4.4 1.8-8.6 3.8-8.7 7.6 0.2 2.6 2.2 4.8 4.7 4.8h23c2.5 0 4.5-2.2 4.5-4.7-0.1-3.8-4.3-5.9-8.7-7.7z m17.2-18.6c0-7.4-6.1-13.5-13.5-13.5v-3.5l-6.8 5.5c-0.3 0.3-0.2 0.8 0.1 1.1l6.7 5.4v-3.5c4.7 0 8.5 3.8 8.5 8.5h-3.5l5.5 6.8c0.3 0.3 0.8 0.3 1.1 0l5.4-6.8h-3.5z"></path>
              </g>
            </svg>
          </div>
          <div>
            <h6>Change Role</h6>
            <small>Updating role of {{ selectedUserName }}</small>
          </div>
        </div>

        <div class="form-container">
          <div class="role">
            <small>Current role:</small>
            <p [ngClass]="selectedUserRole">{{ Helpers.replaceUnderscore(selectedUserRole) }}</p>
          </div>

          <div>
            <label for="newRole">New Role <span class="required-check">*</span></label>
            <select required [(ngModel)]="newRole" name="newRole" id="newRole">
              <option value="" hidden disabled>Select a role</option>



              @for (r of validRoles; track $index) {
                @if (r !== selectedUserRole) {
                  <option [value]="r">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(r)) }}</option>
                }
              }
            </select>
          </div>

          <button class="button" [disabled]="changeRoleForm.invalid" type="submit">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Change role
            }
          </button>

        </div>

      </form>
    </section>
  }

  @if (changeStatus()) {
    <section class="pop-up">
      <div class="bg" (click)="changeStatus.set(false)"></div>

      <form #changeStatusForm="ngForm" (ngSubmit)="editUser(changeStatusForm, 'status')">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52"
                 xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path>
                <path
                  d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path>
                <path
                  d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path>
                <path
                  d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
          </div>
          <div>
            <h6>Change Status</h6>
            <small>Updating status of {{ selectedUserName }}</small>
          </div>
        </div>

        <div class="form-container">
          <div class="status">
            <small>Current status:</small>
            <p [ngClass]="selectedUserStatus">{{ Helpers.replaceUnderscore(selectedUserStatus) }}</p>
          </div>

          <div>
            <label for="newStatus">New Status <span class="required-check">*</span></label>
            <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
              <option value="" hidden disabled>Select a status</option>

              @for (s of validStatuses; track $index) {
                @if (s !== selectedUserStatus) {
                  <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
                }
              }
            </select>

          </div>

          <button class="button" [disabled]="changeStatusForm.invalid" type="submit">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Change status
            }
          </button>

        </div>


      </form>
    </section>
  }

  @if (showAddUser()) {
    <section class="pop-up">
      <div class="bg" (click)="showAddUser.set(false)"></div>

      <form #signupForm="ngForm" (ngSubmit)="signup(signupForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 318.331 318.331" xml:space="preserve"
                 stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M310.331,305.092H8c-4.418,0-8-3.582-8-8V109.059c0-4.418,3.582-8,8-8s8,3.582,8,8v180.033h286.331V109.059 c0-4.418,3.582-8,8-8s8,3.582,8,8v188.033C318.331,301.51,314.749,305.092,310.331,305.092z M261.634,269.336h-18.242 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.242c4.418,0,8,3.582,8,8S266.052,269.336,261.634,269.336z M143.252,269.336h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,269.336,143.252,269.336z M74.941,269.336H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,269.336,74.941,269.336z M279.877,239.262h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S284.295,239.262,279.877,239.262z M211.565,239.262H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,239.262,211.565,239.262z M143.252,208.234h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,208.234,143.252,208.234z M74.941,208.234H38.455 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.486c4.418,0,8,3.582,8,8v30.073 C82.941,204.653,79.359,208.234,74.941,208.234z M46.455,192.234h20.486v-14.073H46.455V192.234z M211.565,178.161H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,178.161,211.565,178.161z M279.877,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C287.877,143.551,284.295,147.132,279.877,147.132z M251.392,131.132h20.485v-14.073h-20.485V131.132z M143.252,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C151.252,143.551,147.67,147.132,143.252,147.132z M114.767,131.132h20.485v-14.073h-20.485V131.132z M211.565,117.059H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,117.059,211.565,117.059z M74.941,117.059H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,117.059,74.941,117.059z M310.331,82.385H8 c-4.418,0-8-3.582-8-8V33.33c0-4.418,3.582-8,8-8h18.171c4.418,0,8,3.582,8,8s-3.582,8-8,8H16v25.056h286.331V41.33h-10.226 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.226c4.418,0,8,3.582,8,8v41.056C318.331,78.804,314.749,82.385,310.331,82.385z M266.919,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C274.919,49.839,271.337,53.42,266.919,53.42z M51.413,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C59.413,49.839,55.831,53.42,51.413,53.42z M242.53,41.33H77.055c-4.418,0-8-3.582-8-8s3.582-8,8-8H242.53c4.418,0,8,3.582,8,8S246.948,41.33,242.53,41.33z"></path> </g></svg>
          </div>
          <div>
            <h6>Add a user</h6>
            <small>Onboard a new user</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="firstName">First Name <span class="required-check">*</span></label>
            <input required [(ngModel)]="firstName" type="text" name="firstName" id="firstName"
                   placeholder="e.g. Elorm">
          </div>

          <div>
            <label for="lastName">Last Name <span class="required-check">*</span></label>
            <input required [(ngModel)]="lastName" type="text" name="lastName" id="lastName" placeholder="e.g. Attoh">
          </div>

          <div class="user-box">
            <label for="username">Username <span class="required-check">*</span></label>
            <input (input)="getAvailableUsers(username)" required [(ngModel)]="username" type="text" name="username"
                   id="username" placeholder="e.g. eattoh25">

            @if (!this.existingUsername() && username.length > 3) {
              <small>username is available</small>
            }

            @if (this.existingUsername() && username.length > 3) {
              <small class="unavailable">username is unavailable</small>
            }
          </div>

          <div>
            <label for="temporaryPassword">Temporary password <span class="required-check">*</span></label>
            <input required [(ngModel)]="temporaryPassword" [type]="showPassword ? 'text' : 'password'"
                   name="temporaryPassword" id="temporaryPassword" placeholder="Enter a temporary password...">

            <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
              @if (!showPassword) {
                <img src="/auth/eye-icon.svg" alt="eye icon">
              } @else {
                <img src="/auth/eye-slash.svg" alt="eye slash icon">
              }
            </button>
          </div>

          <div>
            <label for="role">Role <span class="required-check">*</span></label>
            <select required [(ngModel)]="newUserRole" name="role" id="role">
              <option value="" hidden="">Select a role</option>
              <option value="TEACHER">Teacher</option>
              <option value="FINANCE_ADMIN">Finance Admin</option>
              <option value="SCHOOL_ADMIN">School Admin</option>
            </select>
          </div>

          @if (newUserRole === 'TEACHER') {
            <div>
              <label for="staffNumber">Staff Number <span class="required-check">*</span></label>
              <input required placeholder="e.g. STF103" [(ngModel)]="staffNumber" type="text" name="staffNumber"
                     id="staffNumber">
            </div>

            <div>
              <label for="employmentType">Employment Type <span class="required-check">*</span></label>

              <select [(ngModel)]="employmentType" name="employmentType" id="employmentType">
                <option value="">Select employment type</option>

                @for (a of allowedEmploymentTypes; track $index) {
                  <option [value]="a">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(a)) }}</option>
                }
              </select>
            </div>

            <div>
              <label for="hireDate">Hire Date</label>
              <input [(ngModel)]="hireDate" type="date" name="hireDate" id="hireDate">
            </div>

            <div>
              <label for="specialization">Specialization</label>
              <input placeholder="e.g. Mathematics" [(ngModel)]="specialization" type="text" name="specialization"
                     id="specialization">
            </div>

            <div>
              <label for="qualification">Qualification</label>

              <div class="qualifications">

                <div>
                  <input placeholder="e.g. BSc Mathematics" [(ngModel)]="qualification" type="text" name="qualification"
                         id="qualification">

                  <button type="button" (click)="addQualification()">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
                      <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
                    </svg>

                    <p>Add</p>
                  </button>
                </div>

                <ul>
                  @for (t of qualifications; track t.id) {
                    <li>
                      <p class="list">{{ t.name }}</p>

                      <svg (click)="deleteQualification(t.id)" fill="#fff" viewBox="-3.5 0 19 19"
                           xmlns="http://www.w3.org/2000/svg" class="cf-icon-svg" stroke="#fff">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
                        </g>
                      </svg>
                    </li>
                  }
                </ul>

              </div>

            </div>

            <div>
              <label for="phone">Phone</label>
              <input placeholder="e.g. 055..." [(ngModel)]="phone" type="text" name="phone" id="phone">
            </div>
          }

          <div>
            <button class="secondary-button" type="submit"
                    [disabled]="signupForm.invalid || this.existingUsername() || (temporaryPassword.length < 8) || (newUserRole === 'TEACHER' && (!staffNumber || !employmentType))">
              @if (isSubmitting()) {
                <app-loading-indicator></app-loading-indicator>
              } @else {
                Add User
              }
            </button>
          </div>
        </div>
      </form>
    </section>
  }

  @if (showResetPassword()) {
    <section class="pop-up">
      <div class="bg" (click)="showResetPassword.set(false)"></div>

      <form #resetPasswordForm="ngForm" (ngSubmit)="resetPassword(resetPasswordForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 318.331 318.331" xml:space="preserve"
                 stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M310.331,305.092H8c-4.418,0-8-3.582-8-8V109.059c0-4.418,3.582-8,8-8s8,3.582,8,8v180.033h286.331V109.059 c0-4.418,3.582-8,8-8s8,3.582,8,8v188.033C318.331,301.51,314.749,305.092,310.331,305.092z M261.634,269.336h-18.242 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.242c4.418,0,8,3.582,8,8S266.052,269.336,261.634,269.336z M143.252,269.336h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,269.336,143.252,269.336z M74.941,269.336H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,269.336,74.941,269.336z M279.877,239.262h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S284.295,239.262,279.877,239.262z M211.565,239.262H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,239.262,211.565,239.262z M143.252,208.234h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,208.234,143.252,208.234z M74.941,208.234H38.455 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.486c4.418,0,8,3.582,8,8v30.073 C82.941,204.653,79.359,208.234,74.941,208.234z M46.455,192.234h20.486v-14.073H46.455V192.234z M211.565,178.161H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,178.161,211.565,178.161z M279.877,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C287.877,143.551,284.295,147.132,279.877,147.132z M251.392,131.132h20.485v-14.073h-20.485V131.132z M143.252,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C151.252,143.551,147.67,147.132,143.252,147.132z M114.767,131.132h20.485v-14.073h-20.485V131.132z M211.565,117.059H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,117.059,211.565,117.059z M74.941,117.059H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,117.059,74.941,117.059z M310.331,82.385H8 c-4.418,0-8-3.582-8-8V33.33c0-4.418,3.582-8,8-8h18.171c4.418,0,8,3.582,8,8s-3.582,8-8,8H16v25.056h286.331V41.33h-10.226 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.226c4.418,0,8,3.582,8,8v41.056C318.331,78.804,314.749,82.385,310.331,82.385z M266.919,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C274.919,49.839,271.337,53.42,266.919,53.42z M51.413,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C59.413,49.839,55.831,53.42,51.413,53.42z M242.53,41.33H77.055c-4.418,0-8-3.582-8-8s3.582-8,8-8H242.53c4.418,0,8,3.582,8,8S246.948,41.33,242.53,41.33z"></path> </g></svg>
          </div>
          <div>
            <h6>Reset Password</h6>
            <small>Resetting password of {{ selectedUserName }}</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="resetFirstName">First Name <span class="required-check">*</span></label>
            <input required disabled [(ngModel)]="resetFirstName" type="text" name="resetFirstName"
                   id="resetFirstName" placeholder="e.g. Elorm">
          </div>

          <div>
            <label for="resetLastName">Last Name <span class="required-check">*</span></label>
            <input required disabled [(ngModel)]="resetLastName" type="text" name="resetLastName"
                   id="resetLastName" placeholder="e.g. Attoh">
          </div>

          <div class="user-box">
            <label for="resetUsername">Username <span class="required-check">*</span></label>
            <input required disabled [(ngModel)]="resetUsername" type="text" name="resetUsername"
                   id="resetUsername" placeholder="e.g. eattoh25">
          </div>

          <div>
            <label for="resetRole">Role <span class="required-check">*</span></label>
            <select required disabled [(ngModel)]="resetRole" name="resetRole" id="resetRole">
              <option value="" hidden="">Select a role</option>

              @for (r of validRoles; track $index) {
                <option [value]="r">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(r)) }}</option>
              }
            </select>
          </div>

          <div>
            <label for="resetTemporaryPassword">Temporary password <span class="required-check">*</span></label>
            <input required [(ngModel)]="resetTemporaryPassword" [type]="resetShowPassword ? 'text' : 'password'"
                   name="resetTemporaryPassword" id="resetTemporaryPassword"
                   placeholder="Enter a temporary password...">

            <button type="button" class="toggle-password" (click)="resetShowPassword = !resetShowPassword">
              @if (!resetShowPassword) {
                <img src="/auth/eye-icon.svg" alt="eye icon">
              } @else {
                <img src="/auth/eye-slash.svg" alt="eye slash icon">
              }
            </button>
          </div>

          <div>
            <button class="secondary-button" type="submit"
                    [disabled]="resetPasswordForm.invalid || (resetTemporaryPassword.length < 8)">
              @if (isResetting()) {
                <app-loading-indicator></app-loading-indicator>
              } @else {
                Reset Password
              }
            </button>
          </div>
        </div>
      </form>
    </section>
  }
}
